export default [
  {
    path: '/creators',
    name: 'Creators-list',
    component: () => import('@/components/adm/creators/CreatorsList.vue'),
    meta: {
      title: "Cadastro > Criadores"
    }
  }
]